import { api } from "./api";

export const GET_INSTAGRAM_OVERVIEW = async (oauthId: string) => {
  const { data } = await api.get(`/instagram-analytics/${oauthId}/overview`);
  return data;
};

export const GET_INSTAGRAM_MEDIA = async (oauthId: string) => {
  const { data } = await api.get(`/instagram-analytics/${oauthId}/media`);
  return data;
};

export const GET_INSTAGRAM_MEDIA_DETAILS = async (oauthId: string, mediaId: string) => {
  const { data } = await api.get(`/instagram-analytics/${oauthId}/media/${mediaId}`);
  return data;
};

export const GET_INSTAGRAM_GROWTH = async (
  oauthId: string,
  params?: { dateStart?: string; dateEnd?: string }
) => {
  const { data } = await api.get(`/instagram-analytics/${oauthId}/growth`, {
    params: {
      dateStart: params?.dateStart,
      dateEnd: params?.dateEnd,
      date_start: params?.dateStart,
      date_end: params?.dateEnd,
      startDate: params?.dateStart,
      endDate: params?.dateEnd,
    },
  });
  return data;
};

export const GET_INSTAGRAM_ENGAGEMENT = async (oauthId: string) => {
  const { data } = await api.get(`/instagram-analytics/${oauthId}/engagement`);
  return data;
};

export const GET_INSTAGRAM_BEST_POSTS = async (oauthId: string, limit = 10) => {
  const { data } = await api.get(`/instagram-analytics/${oauthId}/best-posts`, { params: { limit } });
  return data;
};

export const GET_INSTAGRAM_AUDIENCE = async (oauthId: string) => {
  const { data } = await api.get(`/instagram-analytics/${oauthId}/audience`);
  return data;
};

export const SYNC_INSTAGRAM_ANALYTICS = async (oauthId: string) => {
  const { data } = await api.post(`/instagram-analytics/${oauthId}/sync`);
  return data;
};
